import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import "./style.css";

export default function ProfileLoveButton({ profileId, visitor }) {
  const { user } = useSelector((state) => ({ ...state }));
  const [loveStats, setLoveStats] = useState({
    userClickCount: 0,
    totalLoves: 0,
    uniqueLoveUsers: 0,
    privacySettings: {},
  });
  const [loading, setLoading] = useState(false);
  const [animating, setAnimating] = useState(false);
  const [showLoveAnimation, setShowLoveAnimation] = useState(false);

  // Carregar estatísticas ao montar
  useEffect(() => {
    if (profileId && user?.token) {
      fetchLoveStats();
    }
  }, [profileId, user?.token]);

  const fetchLoveStats = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/profiles/${profileId}/love/stats`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      setLoveStats(data);
    } catch (error) {
      console.error("Erro ao carregar estatísticas de amor:", error);
    }
  };

  const handleLoveClick = async () => {
    if (!visitor || loading || !user?.token) return;

    setLoading(true);
    setAnimating(true);
    setShowLoveAnimation(true);

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/profiles/${profileId}/love`,
        {},
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      // Atualizar estado otimista
      setLoveStats((prev) => ({
        ...prev,
        userClickCount: data.clickCount,
        totalLoves: data.totalClicks || data.totalLoves,
      }));

      // Animar
      setTimeout(() => setAnimating(false), 600);
      setTimeout(() => setShowLoveAnimation(false), 1200);
    } catch (error) {
      console.error("Erro ao registrar amor:", error);
      setAnimating(false);
      setShowLoveAnimation(false);
    } finally {
      setLoading(false);
    }
  };

  // Verificar se deve mostrar informações baseado na privacidade
  const canSeeStats = () => {
    const { privacySettings } = loveStats;
    if (!privacySettings.showTotalClicks) return true;

    if (privacySettings.showTotalClicks === "public") return true;
    if (privacySettings.showTotalClicks === "private") return false;
    // friends: depende de se são amigos, mas assumindo que pode ver por agora
    return true;
  };

  if (!user?.token) return null;

  return (
    <div className="profile_love_container">
      <div className="profile_love_wrapper">
        {/* Botão de coração */}
        <div className="profile_love_button_wrapper">
          <button
            className={`profile_love_button ${
              loveStats.userClickCount > 0 ? "loved" : ""
            } ${animating ? "animate" : ""}`}
            onClick={handleLoveClick}
            disabled={loading || !visitor}
            title={visitor ? "Clique para amar este perfil" : "Você não pode amar seu próprio perfil"}
          >
            <span className="heart_emoji">❤️</span>
          </button>

          {/* Animação de corações flutuantes */}
          {showLoveAnimation && (
            <div className="love_animation">
              <span className="floating_heart">❤️</span>
              <span className="floating_heart" style={{ "--delay": "0.1s" }}>
                ❤️
              </span>
              <span className="floating_heart" style={{ "--delay": "0.2s" }}>
                ❤️
              </span>
            </div>
          )}
        </div>

        {/* Texto personalizado para o visitante */}
        <div className="profile_love_counter_text">
          {loveStats.userClickCount === 0
            ? "Você amou 0 vezes"
            : loveStats.userClickCount === 1
            ? "Você amou 1 vez"
            : `Você amou ${loveStats.userClickCount} vezes`}
        </div>

        {/* Contador global (com verificação de privacidade) */}
        {canSeeStats() && (
          <div className="profile_love_total">
            <span className="love_count_number">{loveStats.totalLoves}</span>
            <span className="love_count_label">
              {loveStats.totalLoves === 1 ? "amor recebido" : "amores recebidos"}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
